<div class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/reports']">Reports</a> > Pending Job Data</h3>
    </div>
  </div>
  <div class="form-card">
    <div class="row">
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Select Date Range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input #dateRangeStart matStartDate placeholder="Start date">
            <input #dateRangeEnd matEndDate placeholder="End date" (dateChange)="range.set(dateRangeStart, dateRangeEnd)">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Select City</mat-label>
          <mat-select #cityRef (openedChange)="city.attachScroll(cityRef)" [(value)]="city.selectedId" required>
            <input class="select-input" placeholder="Search..." type="text" autocomplete="off" (keydown)="$event.stopPropagation()" (keyup)="city.onSearch($event)" matInput name="city_list">
            <mat-option [value]="0">All</mat-option>
            <mat-option *ngFor="let opt of city.items" [value]="opt.id">{{opt.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 mb-3">
        <button type="button" mat-flat-button color="primary" (click)="generateReport()">Generate Report</button>
      </div>
    </div>
  </div>
</div>

<div class="report-loading" *ngIf="speaker.isLoading && speaker.listData.length === 0">
  <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  <span>Loading report...</span>
</div>

<app-report-list-container *ngIf="speaker.listData.length > 0"></app-report-list-container>